import { gql } from 'graphql-request';
const collectionByHandleProductHandlesOnly = gql`
    query CollectionByHandleProductHandlesOnlyQuery(
        $country: CountryCode
        $handle: String!
    ) @inContext(country: $country) {
        collection(handle: $handle) {
            id
            title
            handle
            products(first: 250) {
                nodes {
                    handle
                    productType
                }
            }
        }
    }
`;
export default collectionByHandleProductHandlesOnly;
